// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__ZlZOf","videoPlayer":"VideoHero_videoPlayer__occgD","content":"VideoHero_content__lxqJS","placeholder":"VideoHero_placeholder__64EKL"};